import baseApi from 'api/baseApi';
import { ICustomerShort } from 'common/components/PersonProfile/interfaces';
import { IPaginatedData } from 'common/interfaces/pagination';

const posCustomerApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getFrontDeskPosCustomers: builder.query<
      IPaginatedData<ICustomerShort>,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: '/api/v1/front-desk/pos/members',
        method: 'GET',
        params: { search, page, perPage: 30 },
      }),
    }),
    getPosCustomers: builder.query<
      IPaginatedData<ICustomerShort>,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: '/api/v1/pos/members',
        method: 'GET',
        params: { search, page, perPage: 30 },
      }),
    }),
  }),
});

export const {
  useLazyGetFrontDeskPosCustomersQuery: useLazyGetFrontDeskPosCustomers,
  useLazyGetPosCustomersQuery: useLazyGetPosCustomers,
} = posCustomerApi;

export default posCustomerApi;
